import React, { useState } from 'react';

import styled from 'styled-components';

import { useProjectContext } from '@contexts/ProjectContext';

import { NwCard } from '@components/Gui/NwCard/NwCard';
import NwDropDownMenu from '@components/Gui/NwDropDownMenu';
import NwEllipsis from '@components/Gui/NwEllipsis';

import EditAccountingDetailsDrawer from './EditAccountingDetailsDrawer';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const EventFieldsTable = styled.table``;

const NwStyledCard = styled(NwCard)`
    div.accounting-details-card-content {
        padding: 1rem;

        table.details {
            list-style-type: none;
            margin-left: 8px;
            .title-cell {
                border-right: ${(props) => props.theme.DefaultBorder};
                padding-right: 2rem;
                min-width: 10rem;
                font-size: ${(props) => props.theme.FontSizeSm};
                text-transform: uppercase;
                vertical-align: top;
                padding-top: 0.5rem;
            }
            .content-cell {
                padding-left: 20px;
                font-size: 0.95rem;
            }
        }
    }
`;

const AccountingDetailsCard = ({ readOnly }) => {
    const { projectData: currentProject } = useProjectContext();
    const [showEditAccountingDetailsDrawer, setShowEditAccountingDetailsDrawer] = useState(false);

    const actions = () => {
        return [
            <NwDropDownMenu
                size="small"
                actions={[
                    {
                        name: '',
                        key: 'edit',
                        pinned: true,
                        icon: byPrefixAndName.fasl['pen'],
                        action: () => {
                            setShowEditAccountingDetailsDrawer(true);
                        },
                    },
                ]}
            />,
        ];
    };

    return currentProject ? (
        <>
            <NwStyledCard
                title="Accounting Details"
                extra={!readOnly && actions()}
                icon={byPrefixAndName.fasl['cash-register']}
            >
                <div className="accounting-details-card-content">
                    <table className="details">
                        <tbody>
                            <tr>
                                <td className="title-cell">
                                    <strong>P.O. Number</strong>
                                </td>
                                <td className="content-cell" style={{ paddingRight: '4rem' }}>
                                    {currentProject.PONumber || 'n.d.'}
                                </td>
                            </tr>
                            <tr>
                                <td className="title-cell">Accounting Note</td>
                                <td className="content-cell" style={{ paddingRight: '4rem' }}>
                                    <NwEllipsis
                                        text={currentProject.AccountingNote || ''}
                                        rows={5}
                                        expandable
                                        symbol="more"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </NwStyledCard>
            {showEditAccountingDetailsDrawer && (
                <EditAccountingDetailsDrawer
                    project={currentProject}
                    onClose={() => setShowEditAccountingDetailsDrawer(false)}
                />
            )}
        </>
    ) : (
        <div></div>
    );
};

export default AccountingDetailsCard;
